import { Injectable } from '@angular/core';
import { ConfiguracoesProjeto } from '../../../shared';
import { ParametrosService } from '../../../shared/service/parametros.service';

@Injectable()
export class LinkResourcesService {

  private configuracao: ConfiguracoesProjeto;
  private uri_termo_lgpd: string = null;

  constructor(private readonly parametrosService: ParametrosService) { 
    this.DefinirUrlTermoLGPG();
  }

  private DefinirUrlTermoLGPG() {

    this.configuracao = this.parametrosService.getConfiguracao();
    this.uri_termo_lgpd = this.configuracao.uri_termo_lgpd;
  }

    public obterLinkAcessoTermoLGPD(nomeArquivo: string) : string {

        if(!this.uri_termo_lgpd) return;

        return this.uri_termo_lgpd + nomeArquivo;
    }
}



// WEBPACK FOOTER //
// ./src/app/restrito/consumidor/shared/link-resources-service.ts